import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "input"]

  connect() {
    this.hideInput()
  }

  update() {
    if (this.selectTarget.value === "other") {
      this.showInput()
    } else {
      this.hideInput()
    }
  }

  showInput() {
    $(this.inputTarget).parent().show()
    $(this.inputTarget).prop("disabled", false)
  }

  hideInput() {
    $(this.inputTarget).parent().hide()
    $(this.inputTarget).prop("disabled", true)
  }
}
